import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'default' | 'lg' | 'xl';
  fullWidth?: boolean;
  withIcon?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'default',
  fullWidth = false,
  withIcon = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:-translate-y-0.5';
  const variants = {
    primary: 'bg-amber-500 hover:bg-amber-400 text-slate-900 focus:ring-amber-300 border-b-4 border-amber-700 active:border-b-0 active:translate-y-1',
    secondary: 'bg-emerald-700 hover:bg-emerald-600 text-white focus:ring-emerald-400 border-b-4 border-emerald-900 active:border-b-0 active:translate-y-1',
    outline: 'bg-white hover:bg-slate-50 text-slate-700 border-2 border-slate-300 focus:ring-slate-200 shadow-sm'
  };
  const sizes = {
    default: 'text-base py-3 px-6',
    lg: 'text-lg py-4 px-8',
    xl: 'text-xl md:text-2xl py-5 px-10'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClass = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  const content = <>
      {children}
      {withIcon && <ArrowRight className="ml-2 h-6 w-6" strokeWidth={3} data-id="element-172" />}
    </>;
  if (href) {
    return <a href={href} className={combinedClass} target="_blank" rel="noopener noreferrer" data-id="element-173">
        {content}
      </a>;
  }
  return <button className={combinedClass} {...props} data-id="element-174">
      {content}
    </button>;
}